<template>
    <button type="button"
            role="button"
            class="c-minus"
            :class="mode"
            @click="handleClick">
        <div class="line line1"></div>
        <div class="line line2"></div>
        <div class="sr-only">
            {{ $dictionary.get(mode === 'minus' ? 'Product.AddToBasket.AriaLabelRemoveOne' : 'Generic.Cancel') }}
        </div>
    </button>
</template>

<script setup lang="ts">
import { PropType } from 'vue';

const props = defineProps({
    mode: {
        type: String as PropType<'minus' | 'cancel'>,
        required: true,
        default: 'minus',
        validator: (value: string) => ['minus', 'cancel'].includes(value)
    }
});

function handleClick() {
    if (props.mode === 'minus') {
        emit('minus-click');
    } else {
        emit('cancel-click');
    }
}

const emit = defineEmits<{
    (event: 'minus-click'): void;
    (event: 'cancel-click'): void;
}>();
</script>

<style lang="less">
.c-minus {
    position: relative;
    width: 24px;
    height: 34px;

    outline: none;
    &:before {
        @apply absolute bg-green-500 oprema:bg-opremablue-500 rounded-full;
        content: '';
        left: 0;
        top: 5px;
        height: 24px;
        width: 24px;
        transition: all 200ms ease-in;
    }
    .line {
        @apply absolute bg-white;
        height: 2px;
        width: 14px;
        transform: scale3d(0.875, 1, 1);
        left: 5px;
        top: 16px;
        border-radius: 1px;
        transition: color, transform 300ms ease-in-out;
    }

    &.cancel {
        .line {
            background-color: #fff;
        }
        .line1 {
            transform: rotate3d(0, 0, 1, -45deg);
        }
        .line2 {
            transform: rotate3d(0, 0, 1, 45deg);
        }
        &:before {
            @apply bg-red-700 oprema:bg-red-700;
        }
    }
}
</style>
